import {ApiV0} from '../../api.v0';
import {RestApiService} from '../../../rest-api.service';
import {NotificationReq} from '../../../../contracts/socket/notification-req';
import {NotificationSearchReq} from '../../../../contracts/v0/core/notification-req';

export class ApiV0Notifications {
    segment = '/Notifications';

    constructor(v0: ApiV0, private rest: RestApiService) {
        this.segment = v0.segment + this.segment;
    }

    search(take: number = 20, unreadOnly: boolean = false) {
        let dto = new NotificationSearchReq({
            take: take,
            unreadOnly: unreadOnly,
        });

        return this.rest.post<NotificationSearchReq, NotificationReq[]>(
            `${this.segment}/search`,
            Object as any,
            dto
        );
    }

    unreadCount() {
        return this.rest.get<number>(`${this.segment}/unread-count`);
    }

    read(notificationId: number) {
        return this.rest.post<any, object>(
            `${this.segment}/${notificationId}/read`,
            Object as any,
            {}
        );
    }

    readAll() {
        return this.rest.post<any, object>(
            `${this.segment}/read-all`,
            Object as any,
            {}
        );
    }

    clearAll() {
        return this.rest.post<any, object>(
            `${this.segment}/clear-all`,
            Object as any,
            {}
        );
    }
}